/* Kaufbox-Varianten A/B: Darstellung aus den Prototypen (Kit) und deren Übertragung auf Refills und Set.
   Preise, Zustand und Aktionen kommen vom echten Wizard (root.__rzAb). Je Seite liefert der Wizard Rohdaten, build() macht daraus ein Modell. */
(function () {
  'use strict';
  var html = document.documentElement;
  var RH = { 1: 'jeden Monat', 2: 'alle 2 Monate', 3: 'alle 3 Monate', 4: 'alle 4 Monate' };
  function r2(x) { return Math.round(x * 100) / 100; }
  function f(n) { return r2(n).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €'; }
  function variant() { return html.getAttribute('data-rz-ab'); }
  function rh(n) { return RH[n] || 'alle ' + n + ' Monate'; }

  /* ---------- Modelle ---------- */
  // Kit: Starterkit + erster Refill
  function buildKit(w, lion) {
    var d = w.raw(), pack = d.pack, p = d.prices[pack], P = { kitAbo: d.kit.abo / 100, kitOne: d.kit.once / 100 };
    var kitName = lion ? 'Löwen Deal (2 Starterkits + 5 Einwegrasierer)' : 'Starterkit (Griff + 2 Köpfe)', kitShort = lion ? 'Löwen Deal' : 'Kit';
    var each = lion ? 'je ' + pack + 'er' : pack + 'er', refName = lion ? 'Face + Body Refill ' + each : 'Refill ' + pack + 'er';
    var after = p.abo / 100, was = p.once / 100;
    var a = r2(P.kitAbo + after), o = r2(P.kitOne + was);
    return {
      mode: d.mode, step: d.step, rhythm: d.rhythm, months: d.months, pack: pack, packs: d.packs,
      steps: d.mode === 'abo' ? ['kaufart', 'klingen', 'rhythmus'] : ['kaufart', 'klingen'],
      rows: [{ label: kitName, abo: P.kitAbo, once: P.kitOne }, { label: lion ? 'Erste Refills (face + body, ' + each + ')' : 'Erster Refill (' + pack + 'er)', abo: after, once: was }],
      aboTotal: a, onceTotal: o, save: r2(o - a), then: { abo: after, once: was },
      cards: d.packs.map(function (n) { var x = d.prices[n]; return { n: n, label: lion ? n + 'er face + ' + n + 'er body' : n + 'er', count: lion ? n * 2 : n, abo: x.abo / 100, once: x.once / 100 }; }),
      packDone: lion ? 'je ' + pack + 'er' : pack + 'er',
      txt: {
        today: 'heute: ' + kitShort + ' + ' + (lion ? 'erste Refills (' + each + ')' : 'erster Refill (' + pack + 'er)'), onceSubA: kitShort + ' + ' + (lion ? 'Refills (' + each + ')' : 'Refill (' + pack + 'er)'),
        onceSubB: kitShort + ' ' + f(P.kitOne) + ' + ' + (lion ? 'Refills (' + each + ') ' : 'Refill (' + pack + 'er) ') + f(was),
        onceRows: [[kitName, P.kitOne], [lion ? 'Face + Body Refill ' + each : 'Refill ' + pack + 'er', was]],
        sumTitle: 'In deiner ersten Lieferung', sumRows: [[kitName, P.kitAbo, P.kitOne], [refName + ' im Abo', after, was]],
        sumFirst: 'Erste Lieferung', sumNote: lion ? 'Ab der zweiten Lieferung nur noch die Refills (' + each + '): ' + f(after) + ' ' + rh(d.rhythm) + '. Die Griffe bleiben.' : 'Ab der zweiten Lieferung nur noch das Refill (' + pack + 'er): ' + f(after) + ' ' + rh(d.rhythm) + '. Der Griff bleibt.',
        recommendPack: 10
      }
    };
  }
  // Refills: nur Klingen, kein Kit
  function buildRefills(w) {
    var d = w.raw(), pack = d.pack, p = d.prices[pack], after = p.abo / 100, was = p.once / 100;
    return {
      mode: d.mode, step: d.step, rhythm: d.rhythm, months: d.months, pack: pack, packs: d.packs,
      steps: d.mode === 'abo' ? ['kaufart', 'klingen', 'rhythmus'] : ['kaufart', 'klingen'],
      rows: [{ label: 'Refill (' + pack + 'er)', abo: after, once: was }],
      aboTotal: after, onceTotal: was, save: r2(was - after), then: { abo: after, once: was },
      cards: d.packs.map(function (n) { var x = d.prices[n]; return { n: n, label: n + 'er', count: n, abo: x.abo / 100, once: x.once / 100 }; }),
      packDone: pack + 'er',
      txt: {
        today: 'heute: Refill (' + pack + 'er)', onceSubA: 'Refill (' + pack + 'er)', onceSubB: 'Refill (' + pack + 'er) ' + f(was) + ' · ' + f(was / pack) + ' pro Klinge',
        onceRows: [['Refill ' + pack + 'er', was]],
        sumTitle: 'In deiner ersten Lieferung', sumRows: [['Refill ' + pack + 'er im Abo', after, was]],
        sumFirst: 'Je Lieferung', sumNote: 'Danach jede Lieferung ' + f(after) + ' ' + rh(d.rhythm) + '. ' + f(after / pack) + ' pro Klinge.',
        recommendPack: d.popular || 10
      }
    };
  }
  // Set: Kit + Klingen + Soap + Brow Razor; Anker ist der Einzelwert aller Teile
  function buildSet(w) {
    var d = w.raw(), rows = d.rows.map(function (r) { return { label: r.label, abo: r.abo / 100, once: r.single / 100 }; });
    var a = r2(d.aboTotal / 100), o = r2(d.onceTotal / 100), value = r2(d.value / 100);
    var then = d.then ? { abo: d.then.abo / 100, once: d.then.single / 100 } : null;
    return {
      mode: d.mode, step: d.step, rhythm: d.rhythm, months: d.months, pack: null, packs: null,
      steps: d.mode === 'abo' ? ['kaufart', 'rhythmus'] : ['kaufart'],
      rows: rows, aboTotal: a, onceTotal: value > 0 ? value : o, onceReal: o, save: value > 0 ? r2(value - a) : 0, then: then, set: true,
      txt: {
        today: 'heute: ' + d.contents, onceSubA: d.contents, onceSubB: d.contents,
        onceRows: [], sumTitle: 'In deiner ersten Lieferung', sumRows: rows.map(function (r) { return [r.label, r.abo, r.once]; }),
        sumFirst: 'Erste Lieferung', sumNote: 'Danach nur noch ' + d.size + ' Klingenköpfe: ' + f(then ? then.abo : 0) + ' ' + rh(d.rhythm) + '.'
      }
    };
  }
  var BUILD = { kit: buildKit, lion: function (w) { return buildKit(w, true); }, refills: buildRefills, set: buildSet };

  /* ---------- Bausteine ---------- */
  function strike(v) { return '<s class="s"><span class="rz-visually-hidden">vorher </span>' + v + '</s>'; }
  function bar(m) { var h = '<div class="pb">'; for (var i = 1; i <= m.steps.length; i++) h += '<i class="' + (i <= m.step ? 'on' : '') + '"></i>'; return h + '</div>'; }
  function head(n, label) { return '<p class="sh"><span class="n">' + n + '</span>' + label + '</p>'; }
  function done(n, label, val) { return '<div class="done"><span class="n">✓</span><span class="l">' + label + '</span><b>' + val + '</b><button type="button" data-a="go" data-v="' + n + '">Ändern</button></div>'; }
  function num(i) { return '0' + (i + 1); }
  function priceBig(m, S, size) { return f(m.aboTotal) + '</span> <span class="s" style="font-size:' + size + 'px"><span class="rz-visually-hidden">vorher </span>' + f(m.onceTotal) + S + '</span>'; }

  function stepKaufart(m, ctx, last) {
    var V = variant(), S = ctx.S, aboSel = m.mode === 'abo', anchor = m.onceTotal > m.aboTotal, h = head('01', 'Kaufart');
    var abo = '<button type="button" class="card' + (aboSel ? ' sel' : ' dim') + '" data-a="type" data-v="abo" aria-pressed="' + aboSel + '">';
    var pill = '<span class="tg">Empfohlen</span>' + (anchor ? '<span class="sv">Du sparst ' + f(m.save) + S + '</span>' : '');
    var thenLine = m.then ? '<span class="s"><span class="rz-visually-hidden">vorher </span>' + f(m.then.once) + '</span>' : '';
    if (V === 'variant_a') {
      abo += pill + '<div class="ct">Mit Klingen-Abo</div>'
        + '<div style="margin-top:2px"><span class="big">' + (anchor ? priceBig(m, S, 16) : f(m.aboTotal) + '</span>') + '</div>'
        + '<div class="sm" style="margin:2px 0 8px">' + m.txt.today + '</div>'
        + (m.then ? '<div class="sm" style="border-top:1px solid var(--line);padding-top:8px;color:var(--ink)">Danach ' + f(m.then.abo) + ' ' + (m.then.once > m.then.abo ? thenLine + ' ' : '') + rh(m.rhythm)
          + ' <span class="lk" data-a="rh" role="button" tabindex="0">Rhythmus ändern</span></div>' : '');
    } else {
      abo += pill + '<div class="ct" style="margin-bottom:6px">Mit Klingen-Abo</div>';
      m.rows.forEach(function (r) { abo += '<div class="row"><span>' + r.label + '</span><span>' + f(r.abo) + (r.once > r.abo ? ' ' + strike(f(r.once)) : '') + '</span></div>'; });
      abo += '<div class="row tot"><span>Heute</span><span class="v">' + f(m.aboTotal) + (anchor ? ' <span class="s" style="font-size:14px"><span class="rz-visually-hidden">vorher </span>' + f(m.onceTotal) + S + '</span>' : '') + '</span></div>'
        + (m.then ? '<div class="sm" style="margin-top:6px">Danach ' + f(m.then.abo) + (m.then.once > m.then.abo ? ' statt ' + f(m.then.once) : '') + ' ' + rh(m.rhythm)
          + ' <span class="lk" data-a="rh" role="button" tabindex="0">Rhythmus ändern</span></div>' : '');
    }
    abo += '</button>';
    var one = '<button type="button" class="card' + (!aboSel ? ' sel' : '') + '" data-a="type" data-v="once" aria-pressed="' + (!aboSel) + '">';
    var oT = m.set ? m.onceReal : m.onceTotal;
    if (V === 'variant_a') {
      one += '<div class="ct" style="margin:0">Einmalig kaufen</div><div style="margin-top:2px"><span style="font-size:19px;font-weight:500">' + f(oT) + (m.set ? '' : S) + '</span> <span class="sm">' + m.txt.onceSubA + '</span></div>';
    } else {
      one += '<div class="row" style="color:var(--ink)"><span style="font-weight:500;font-size:15px">Einmalig kaufen</span><span style="font-size:17px;font-weight:500">' + f(oT) + (m.set ? '' : S) + '</span></div>'
        + '<div class="sm">' + m.txt.onceSubB + '</div>';
    }
    one += '</button>';
    h += abo + one + '<button type="button" class="next full" data-a="' + (last ? 'cta' : 'next') + '">' + (last ? 'in den warenkorb' : 'weiter →') + '</button>';
    if (aboSel && ctx.note) h += '<p class="mn">' + ctx.note + '</p>';
    return h;
  }
  function stepKlingen(m, ctx) {
    var S = ctx.S, h = head('02', 'Klingen'), abo = m.mode === 'abo';
    m.cards.forEach(function (c) {
      var sel = m.pack === c.n, pr = abo ? c.abo : c.once, was = abo && c.once > c.abo ? c.once : null;
      h += '<button type="button" class="card' + (sel ? ' sel' : '') + '" data-a="pack" data-v="' + c.n + '" aria-pressed="' + sel + '"><div class="pk"><div>'
        + (c.n === m.txt.recommendPack && abo ? '<span class="tg">Empfohlen</span>' : '') + '<div class="ct" style="margin-top:' + (c.n === m.txt.recommendPack && abo ? 8 : 0) + 'px">' + c.label + '</div>'
        + '<div class="sm">' + f(pr / c.count) + ' pro Klinge</div></div><div class="r"><div style="font-size:20px;font-weight:500">' + f(pr) + '</div>'
        + (was ? '<div class="s sm"><span class="rz-visually-hidden">vorher </span>' + f(was) + '</div>' : '') + '</div></div></button>';
    });
    if (abo) {
      var anchor = m.onceTotal > m.aboTotal;
      h += '<div class="live">Heute <b>' + f(m.aboTotal) + '</b> ' + (anchor ? '<span class="s"><span class="rz-visually-hidden">vorher </span>' + f(m.onceTotal) + S + '</span> ' : '') + '· danach ' + f(m.then.abo) + ' ' + rh(m.rhythm) + '</div>'
        + '<button type="button" class="next full" data-a="next">weiter →</button>';
    } else {
      h += summary(m, ctx) + '<button type="button" class="next full" data-a="cta">in den warenkorb</button>';
    }
    return h;
  }
  function summary(m, ctx) {
    var S = ctx.S, t = m.txt, h = '<div class="sumbox">';
    if (m.mode === 'abo') {
      var anchor = m.onceTotal > m.aboTotal;
      h += '<div class="sm" style="letter-spacing:.06em;text-transform:uppercase;margin-bottom:4px">' + t.sumTitle + '</div>';
      t.sumRows.forEach(function (r) { h += '<div class="row"><span>' + r[0] + '</span><span>' + f(r[1]) + (r[2] > r[1] ? ' ' + strike(f(r[2])) : '') + '</span></div>'; });
      h += '<div class="row tot"><span>' + t.sumFirst + '</span><span class="v">' + f(m.aboTotal) + (anchor ? ' <span class="s" style="font-size:14px"><span class="rz-visually-hidden">vorher </span>' + f(m.onceTotal) + S + '</span>' : '') + '</span></div>'
        + '<div class="sm" style="margin-top:6px">' + t.sumNote + (anchor ? ' <span class="sv" style="margin-left:0">Du sparst ' + f(m.save) + S + '</span>' : '') + '</div>';
    } else {
      h += '<div class="sm" style="letter-spacing:.06em;text-transform:uppercase;margin-bottom:4px">Einmaliger Kauf</div>';
      t.onceRows.forEach(function (r) { h += '<div class="row"><span>' + r[0] + '</span><span>' + f(r[1]) + '</span></div>'; });
      h += '<div class="row tot"><span>Gesamt' + S + '</span><span class="v">' + f(m.onceTotal) + '</span></div>';
    }
    return h + '</div>';
  }
  function stepRhythmus(m, ctx, idx) {
    var h = head(num(idx), 'Rhythmus');
    h += '<div class="ch" role="group" aria-label="Lieferrhythmus">';
    m.months.forEach(function (n) { h += '<button type="button" class="' + (m.rhythm === n ? 'on' : '') + '" data-a="rhy" data-v="' + n + '" aria-pressed="' + (m.rhythm === n) + '">' + rh(n) + '</button>'; });
    h += '</div>' + summary(m, ctx) + '<button type="button" class="next full" data-a="cta">in den warenkorb</button>';
    if (ctx.note) h += '<p class="mn">' + ctx.note + '</p>';
    return h;
  }

  function render(mount) {
    var root = mount.closest('[data-rz-ab-root]') || mount.parentNode, w = root && root.__rzAb, V = variant();
    if (!w || (V !== 'variant_a' && V !== 'variant_b')) { mount.innerHTML = ''; return; }
    var m = BUILD[w.kind](w), foot = mount.getAttribute('data-foot') || '', ctx = { note: mount.getAttribute('data-note') || '', S: foot ? '*' : '' };
    var h = bar(m), abo = m.mode === 'abo';
    m.steps.forEach(function (id, i) {
      var n = i + 1; if (n > m.step) return;
      var isLast = n === m.steps.length, body;
      if (n < m.step) body = done(n, id === 'kaufart' ? 'Kaufart' : id === 'klingen' ? 'Klingen' : 'Rhythmus', id === 'kaufart' ? (abo ? 'Mit Klingen-Abo' : 'Einmaliger Kauf') : id === 'klingen' ? m.packDone : rh(m.rhythm));
      else if (id === 'kaufart') body = stepKaufart(m, ctx, isLast);
      else if (id === 'klingen') body = stepKlingen(m, ctx);
      else body = stepRhythmus(m, ctx, i);
      h += '<div class="stp">' + body + '</div>';
    });
    mount.innerHTML = h;
  }

  function bind(mount) {
    if (mount.__rzBound) return; mount.__rzBound = true;
    mount.addEventListener('click', function (e) {
      var el = e.target.closest('[data-a]'); if (!el) return;
      e.preventDefault(); e.stopPropagation();
      mount.closest('[data-rz-ab-root]').__rzAb.act(el.getAttribute('data-a'), el.getAttribute('data-v'));
    });
    mount.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.getAttribute && e.target.getAttribute('data-a') === 'rh') { e.preventDefault(); mount.closest('[data-rz-ab-root]').__rzAb.act('rh'); }
    });
  }
  function all() { Array.prototype.forEach.call(document.querySelectorAll('[data-rz-ab-mount]'), function (m) { bind(m); render(m); }); }
  document.addEventListener('rz:box-update', function (e) {
    var root = e.target.closest ? e.target.closest('[data-rz-ab-root]') : null; if (!root) return;
    var m = root.querySelector('[data-rz-ab-mount]'); if (m) { bind(m); render(m); }
  });
  document.addEventListener('rz:ab', all);
  all();
})();
